module.exports = __webpack_public_path__ + "assets/redpack-qn-top-bg-2084780b.png";